<template>
  <div v-if="transport">
    <b-row class="align-items-center mb-2">
      <b-col cols="3"></b-col>

      <b-col cols="6" class="text-center">
        <div class="mb-3">
          بسمه تعالی
        </div>

        <div class="text-center mb-0">
          <div class="h3 mb-2">
            مجوز حمل
          </div>

          مسئولیت اطلاعات وارده شده با شرکت حمل و نقل می باشد.
        </div>
      </b-col>

      <b-col cols="3" class="text-left">
        <b-btn
          class="d-print-none mb-3"
          :title="$t('shared.printThisPage')"
          @click="print"
        >
          <font-awesome-icon
            icon="print"
            class="align-middle"
            fixed-width
          />
        </b-btn>

        <div class="ml-3">
          <div class="mb-2 ml-5">
            شماره مجوز شرکت حمل کننده :
          </div>

          <div class="ml-5">
            تاریخ :

            <date-display :value="new Date().toISOString()" icon-class=""/>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateDisplay from '@/components/shared/DateDisplay'

export default {
  name: 'PageHeader',
  components: {
    DateDisplay
  },
  props: {
    transport: { type: Object, required: true }
  },
  methods: {
    print () {
      window.print()
    }
  }
}
</script>
